import React from 'react'
import { createContext, useContextSelector } from 'use-context-selector'
import { useWeekdayFilterState } from 'app/@hooks'
import CompetitionAnalyzerReportExecutionContext from '../../../Providers/@contexts/reportExecution'

const Context = createContext({})

export function CompetitionAnalyzerWeekdayFilterProvider({ children }) {
	const reportWeekdays = useContextSelector(CompetitionAnalyzerReportExecutionContext, ({ state }) => state.weekdays)
	const { state, updateState } = useWeekdayFilterState(reportWeekdays)

	return <Context.Provider value={{ state, updateState }}>
		{children}
	</Context.Provider>
}

export default Context
